<template>
  <pop-panel :name="'修改手机号'">
    <component :is="currentPage" :form="form" @change="changeHandler"/>
  </pop-panel>
</template>

<script>
  import PopPanel from "@components/popPanel/index";
  import OneStep from "./oneStep";
  import TwoStep from "./twoStep";
  import _ from 'lodash'
  export default {
    name: "safe-change-phone",
    components: {TwoStep, OneStep, PopPanel},
    mounted () {
      // 缓存默认form表单
      this.originForm = _.cloneDeep(this.form)
    },
    data () {
      return {
        currentPage: OneStep,
        components: {
          OneStep,
          TwoStep
        },
        originForm: {},
        form: {
          buzzCode: {
            value: '',
          },
          name: {
            value: '',
            validateStatus: '',
            help: '昵称需唯一'
          },
          code: {
            value: '',
            validateStatus: '',
            help: ''
          },
          newCode: {
            value: '',
            validateStatus: '',
            help: ''
          },
          origVerifyCode: {
            value: '',
            validateStatus: '',
            help: ''
          },
          newPhone: {
            value: '',
            validateStatus: '',
            help: '系统会校验唯一性，已存在则无法修改成功'
          },
          newVerifyCode: {
            value: '',
            validateStatus: '',
            help: ''
          },
        }
      }
    },
    methods: {
      changeHandler (stepName) {
        //清空校验
        // this.form = _.cloneDeep(this.originForm)
        this.currentPage = this.components[stepName]
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
